import { FC } from 'react'
import PrintedTicketPart from '@/root/modules/tuuleliinid/PrintedTicket/components/PrintedTicketPart/PrintedTicketPart'

import { TicketProps } from '@/root/shared-types/reservation/reservation-types'
import { Divider } from '@/root/ui/tuuleliinid/Divider/Divider'

export const PrintedTicket: FC<TicketProps> = ({ ticketData, hideQrCode }) => {
  const { customerInfo, reservationId, there, back, isRoundTrip, status } = ticketData

  const numOfCycles = there?.vehicles?.filter((v) => v.type === 'BICYCLE')?.length

  const isCancelledReservation = status === 'CN'
  const cancelledThere = there.isRefund || there.isCancelled || isCancelledReservation
  const cancelledBack = back.isRefund || back.isCancelled || isCancelledReservation

  return (
    <div className="mb-8 rounded-xl border bg-white p-8">
      <PrintedTicketPart
        reservationId={reservationId}
        cancelled={cancelledThere}
        cancelledByAdmin={there.isCancelled || back.isCancelled}
        {...there}
        customerInfo={customerInfo}
        numOfCycles={numOfCycles}
        hideQrCode={hideQrCode || cancelledThere}
      />

      {isRoundTrip && (
        <>
          <Divider color="black" type="dotted" />
          <PrintedTicketPart
            reservationId={reservationId}
            cancelled={cancelledBack}
            cancelledByAdmin={there.isCancelled || back.isCancelled}
            {...back}
            hideQrCode={hideQrCode || cancelledBack}
          />
        </>
      )}
    </div>
  )
}

export default PrintedTicket
